import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { User, LoginPostBody, LoginResponse } from './auth.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  readonly #http = inject(HttpClient);
  readonly #authUrl = `${environment.authHost}/api/auth`;

  login({ username, password }: LoginPostBody) {
    return this.#http.post<LoginResponse | undefined>(`${this.#authUrl}/login/`, {
      username,
      password
    });
  }

  refreshToken(token: string) {
    return this.#http.post<LoginResponse>(`${this.#authUrl}/refresh_token/`, {
      refresh_token: token
    });
  }

  updateUserData(data: User['data']) {
    return this.#http.post<User>(`${environment.authHost}/api/user/profile/`, {
      data
    });
  }

  getUser() {
    return this.#http.post<User>(`${environment.authHost}/api/user/info/`, null);
  }
}
